import {
  useQuery,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';
import { QueryFetchFunction, QueryTransformer } from 'common/helpers/common';
import { ApiError, ExtendedApiResult } from 'common/repositories/common.model';

import { CommissionModel, getCommissionInput } from './model';

export function useGetCommission(
  input?: getCommissionInput,
  options?: UseQueryOptions<ExtendedApiResult<CommissionModel[]>, ApiError>,
): UseQueryResult<ExtendedApiResult<CommissionModel[]>, ApiError> {
  return QueryTransformer(
    useQuery(
      ['getCommission', input?.params],
      () =>
        QueryFetchFunction({
          url: `tours/${input?.id}/get-commissions`,
          params: input?.params,
        }),
      options,
    ),
    CommissionModel,
  );
}
